import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

const odsModalStepsVideoConsultation = [
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModalVC.process.step1"
    key="pdp.buyboxwithvariants.odsModalVC.process.step1"
  />,
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModalVC.process.step2"
    key="pdp.buyboxwithvariants.odsModalVC.process.step2"
  />,
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModalVC.process.step3"
    key="pdp.buyboxwithvariants.odsModalVC.process.step3"
  />,
]

export const ProductPageOdsDialogVideoConsultationStepsSection: FC = () => {
  return (
    <ul className="list-numbered-hexagon mt-3.5">
      {odsModalStepsVideoConsultation.map((step, index) => (
        // eslint-disable-next-line react/no-array-index-key -- since the list is not changing, we can use the index as key
        <li key={index}>{step}</li>
      ))}
    </ul>
  )
}
